import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  theme: 'light' | 'dark' | 'system';
}

interface SettingsActions {
  setTheme: (theme: 'light' | 'dark' | 'system') => void;
  reset: () => void;
}

type SettingsStore = SettingsState & SettingsActions;

const initialState: SettingsState = {
  theme: 'system',
};

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      ...initialState,

      setTheme: (theme) => set({ theme }),

      reset: () => set(initialState),
    }),
    {
      name: 'flag-trainer-settings',
      version: 2,
      migrate: (persistedState, version) => {
        // Clear old settings fields on version upgrade
        if (version < 2) {
          return { theme: (persistedState as SettingsState)?.theme ?? 'system' };
        }
        return persistedState as SettingsState;
      },
    }
  )
);
